import { render, staticRenderFns } from "./PHeader.vue?vue&type=template&id=deb6f8f0&scoped=true"
import script from "./PHeader.vue?vue&type=script&lang=js"
export * from "./PHeader.vue?vue&type=script&lang=js"
import style1 from "./PHeader.vue?vue&type=style&index=1&id=deb6f8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb6f8f0",
  null
  
)

export default component.exports